import { useLanguageContext } from '../context/languageContext';
import { ArrowUpRight } from 'lucide-react';
import LivePrices from './LivePrices';

const activitiesUrl = 'https://www.getyourguide.com/durres-l2796/?partner_id=S9W35E3&utm_medium=online_publisher&cmp=cialda-menu';
const activities = [
  {
    "titles": {
      "en": "Holta Canyon & Banja Lake",
      "sq": "Kanioni i Holtës dhe liqeni i Banjës",
      "it": "Canyon di Holta e lago di Banja"
    },
    "url": "https://www.getyourguide.com/durres-l2796/from-durresgolem-holta-canyon-and-picnic-trip-t1132594/",
    "image": "https://cdn.getyourguide.com/image/format=auto%2Cfit=cover%2Cgravity=auto%2Cquality=60%2Cwidth=270%2Cheight=180%2Cdpr=1/tour_img/53e885e0ca9eeb8df477a90ec4310e641315b36c439eeccd4ca163ce5ae46442.jpeg"
  },
  {
    "titles": {
      "en": "Sazan Island & Karaburun boat trip",
      "sq": "Shëtitje me varkë në Sazan dhe Karaburun",
      "it": "Tour in barca a Sazan e Karaburun"
    },
    "url": "https://www.getyourguide.com/durres-l2796/durres-tirana-speed-boat-trip-to-sazan-karaburun-cave-t949443/",
    "image": "https://cdn.getyourguide.com/image/format=auto%2Cfit=cover%2Cgravity=auto%2Cquality=60%2Cwidth=270%2Cheight=180%2Cdpr=1/tour_img/ab882359c7ed92346e8bbd176a3fb6cc7399d230e65d2e0a2ffb6db5cf6537ad.jpg"
  },
  {
    "titles": {
      "en": "Berat UNESCO & Belshi Lake",
      "sq": "Berati UNESCO dhe liqeni i Belshit",
      "it": "Berat UNESCO e lago di Belsh"
    },
    "url": "https://www.getyourguide.com/berat-l2798/tirana-berat-and-durres-day-trip-with-free-time-t1217342/",
    "image": "https://cdn.getyourguide.com/image/format=auto%2Cfit=cover%2Cgravity=auto%2Cquality=60%2Cwidth=270%2Cheight=180%2Cdpr=1/tour_img/2efa774cc96538b41260bd4b17381e8639fc8c9ebe80f89d7c23d088aa12e9bf.jpg"
  }
];

export default function TravelActivities({ popup = false }) {
  const { language } = useLanguageContext();
  const activityLanguage = language === 'sq' ? 'sq' : language?.toLowerCase() === 'it' ? 'it' : 'en';
  const copy = language === 'sq' ? {
    title: 'Zbuloni Durrësin',
    description: 'Shikoni ture, shëtitje dhe aktivitete në Durrës me GetYourGuide.',
    action: 'Shikoni aktivitetet',
    disclosure: 'Lidhje affiliate: mund të marrim komision nëse rezervoni përmes kësaj lidhjeje.',
  } : language?.toLowerCase() === 'it' ? {
    title: 'Esplora Durazzo',
    description: 'Scopri tour, passeggiate e attività a Durazzo con GetYourGuide.',
    action: 'Scopri le attività',
    disclosure: 'Link affiliato: potremmo ricevere una commissione se prenoti tramite questo link.',
  } : {
    title: 'Explore Durrës',
    description: 'Discover tours, walking trips and activities in Durrës with GetYourGuide.',
    action: 'Explore activities',
    disclosure: 'Affiliate link: we may earn a commission if you book through this link.',
  };

  return (
    <section id={popup ? undefined : 'activities'} aria-labelledby={popup ? 'travel-popup-title' : 'travel-activities-title'} className={popup ? '' : 'bg-cream px-4 py-8'}>
      <div className={popup ? 'overflow-hidden bg-white p-4 sm:p-5' : 'mx-auto max-w-5xl overflow-hidden rounded-3xl border border-stone-200 bg-white p-4 shadow-sm sm:p-8'}>
        <div className={popup ? 'mb-2 flex items-center gap-2 pr-12' : 'mb-4 flex items-center gap-3 border-b border-stone-100 pb-4'}>
          <img src="/getyourguide-logo.svg" alt="GetYourGuide" width="64" height="52" className={popup ? 'h-9 w-12 shrink-0 object-contain' : 'h-12 w-16 object-contain'} />
          <span className="text-sm font-medium text-slate-500">{activityLanguage === 'sq' ? 'Ture dhe aktivitete' : activityLanguage === 'it' ? 'Tour ed esperienze' : 'Tours & experiences'}</span>
        </div>
        <h2 id={popup ? 'travel-popup-title' : 'travel-activities-title'} className={popup ? 'text-xl font-bold text-slate-900' : 'text-2xl sm:text-3xl font-bold text-slate-900'}>{copy.title}</h2>
        {!popup && <p className="mt-3 text-sm text-gray-600">{copy.description}</p>}
        <div aria-label={copy.title} className={`${popup ? 'mt-3 pb-2' : 'mt-5 pb-4'} flex snap-x snap-mandatory gap-3 overflow-x-auto overscroll-x-contain sm:grid sm:grid-cols-3 sm:gap-5`}>
          {activities.map(({ titles, url, image }) => (
            <a key={url} href={`${url}?partner_id=S9W35E3&utm_medium=online_publisher&cmp=cialda-menu`} target="_blank" rel="sponsored noopener noreferrer" className="group flex w-[86%] shrink-0 snap-start flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600 sm:w-auto">
              <div className={popup ? 'relative h-32 overflow-hidden bg-slate-100 sm:h-36' : 'relative aspect-[3/2] overflow-hidden bg-slate-100'}>
                <img src={image.replace('width=270', 'width=540').replace('height=180', 'height=360')} alt={titles[activityLanguage]} loading="lazy" width="540" height="360" referrerPolicy="no-referrer" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                <span className="absolute bottom-3 left-3 rounded-full bg-white/95 px-3 py-1 text-xs font-semibold text-slate-800">Durrës · Albania</span>
              </div>
              <div className={popup ? 'flex flex-1 flex-col p-3' : 'flex flex-1 flex-col p-4'}>
                <h3 className="min-h-[3rem] text-base font-bold leading-snug text-slate-900">{titles[activityLanguage]}</h3>
                <span className={`${popup ? 'mt-2' : 'mt-4'} flex min-h-[48px] items-center justify-between gap-2 rounded-xl bg-orange-600 px-4 py-3 text-sm font-semibold text-white group-hover:bg-orange-700`}>{copy.action}<ArrowUpRight aria-hidden="true" className="h-4 w-4 shrink-0" /></span>
              </div>
            </a>
          ))}
        </div>
        <a href={activitiesUrl} target="_blank" rel="sponsored noopener noreferrer" className="mt-2 flex min-h-[48px] items-center justify-center gap-2 rounded-xl border border-orange-200 bg-orange-50 px-5 py-3 text-sm font-bold text-orange-700 hover:bg-orange-100 sm:inline-flex">{copy.action}<ArrowUpRight aria-hidden="true" className="h-4 w-4" /></a>
        <LivePrices provider="gyg" />
        <p className="mt-3 text-xs leading-relaxed text-gray-600">{copy.disclosure}</p>
      </div>
    </section>
  );
}
